const KEY_WATCHED_EPISODE_IDS = 'watched_episode_ids'

export function getWatchedEpisodeIds() {
  let ids = []

  try {
    ids = [...JSON.parse(localStorage.getItem(KEY_WATCHED_EPISODE_IDS) || '[]')]
  } catch {
    ids = []
  }

  return ids
}

export function setWatchedEpisode(episode) {
  const watchedEpisodeIds = getWatchedEpisodeIds()

  if (watchedEpisodeIds.includes(episode.id)) {
    return
  }

  watchedEpisodeIds.push(episode.id)

  localStorage.setItem(KEY_WATCHED_EPISODE_IDS, JSON.stringify(watchedEpisodeIds))
}
